import React from 'react';
import { useSelector } from 'react-redux';

export default function VehicleList({ onSelect, onLocate }) {
  const { live } = useSelector((s) => s.vehicles);
  const vehicles = Object.values(live).sort((a, b) => {
    if (a.status === 'sos' && b.status !== 'sos') return -1;
    if (b.status === 'sos' && a.status !== 'sos') return 1;
    return (b.speed || 0) - (a.speed || 0);
  });

  return (
    <div style={{ maxHeight: 400, overflowY: 'auto' }}>
      {vehicles.length === 0 && (
        <div style={{ textAlign: 'center', color: '#555', padding: 20 }}>
          Aucun véhicule en ligne
        </div>
      )}
      {vehicles.map((v) => {
        const speedColor = (v.speed || 0) > 120 ? '#ff1744' : (v.speed || 0) > 80 ? '#ff9100' : '#00e676';
        return (
          <div
            key={v.vehicle_id}
            className="vehicle-list-item"
            onClick={() => onSelect(v.vehicle_id)}
          >
            <i
              className={`bi ${v.status === 'sos' ? 'bi-exclamation-triangle-fill' : 'bi-truck'}`}
              style={{ fontSize: 18, color: v.status === 'sos' ? '#ff1744' : '#00e676' }}
            ></i>
            <div>
              <div className="plate">{v.plate || `#${v.vehicle_id}`}</div>
              <div style={{ fontSize: 11, color: '#888' }}>{v.driver_name || 'Inconnu'}</div>
            </div>
            {v.status === 'sos' && <span className="badge-sos">SOS</span>}
            <div className="speed" style={{ color: speedColor }}>
              {Math.round(v.speed || 0)} <span style={{ fontSize: 10, color: '#888' }}>km/h</span>
            </div>
            {onLocate && (
              <button
                className="locate-btn"
                title="Voir la position"
                onClick={(e) => { e.stopPropagation(); onLocate(v.vehicle_id); }}
              >
                <i className="bi bi-crosshair" style={{ fontSize: 16 }}></i>
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
